
export type Language = 'en' | 'hi';

export const translations = {
  en: {
    heroTitle: "Find the Extreme Gadget.",
    heroSubtitle: "The world's first decentralized hub for boutique electronics.",
    shopNow: "Shop Now",
    openStore: "Open Your Store",
    addToCart: "Add to Cart",
    inStock: "In Stock",
    outOfStock: "Sold Out",
    searchPlaceholder: "Search gadgets...",
    home: "Home",
    gadgets: "Gadgets",
    myOrders: "My Orders",
    adminPanel: "Admin Panel",
    dashboard: "Dashboard",
    analytics: "Analytics",
    products: "Products",
    // Added missing translation for categories
    categories: "Categories",
    orders: "Orders",
    settings: "Settings",
    revenue: "Revenue",
    welcomeBack: "Welcome back, Chief!",
    aiDescribe: "AI DESCRIBE"
  },
  hi: {
    heroTitle: "बेहतरीन गैजेट खोजें।",
    heroSubtitle: "बुटीक इलेक्ट्रॉनिक्स के लिए दुनिया का पहला विकेंद्रीकृत हब।",
    shopNow: "अभी खरीदें",
    openStore: "अपनी दुकान खोलें",
    addToCart: "कार्ट में जोड़ें",
    inStock: "स्टॉक में है",
    outOfStock: "बिक गया",
    searchPlaceholder: "गैजेट खोजें...",
    home: "होम",
    gadgets: "गैजेट्स",
    myOrders: "मेरे ऑर्डर्स",
    adminPanel: "एडमिन पैनल",
    dashboard: "डैशबोर्ड",
    analytics: "एनालिटिक्स",
    products: "प्रोडक्ट्स",
    // Added missing translation for categories
    categories: "कैटेगरीज़",
    orders: "ऑर्डर्स",
    settings: "सेटिंग्स",
    revenue: "कुल कमाई",
    welcomeBack: "स्वागत है, बॉस!",
    aiDescribe: "AI विवरण"
  }
};